import { render, staticRenderFns } from "./KnowledgeHubList.vue?vue&type=template&id=00b0358c&"
import script from "./KnowledgeHubList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeHubList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports